import { useEffect } from 'react';

import styled from '@emotion/styled';

import useVtpassBalanceStatus from '../../hooks/dashboard/ops/useVtpassBalanceStatus';
import { formatNaira } from '../../utils/utils';

const REFRESH_MS = 60_000;

// Shown on every dashboard page while the VTpass wallet is low, almost
// empty, or can't be read (docs/ops-and-account-acceptance-criteria.md V6).
const VtpassBalanceBanner = () => {
  const { status, fetchStatus } = useVtpassBalanceStatus();

  useEffect(() => {
    fetchStatus();
    const timer = setInterval(fetchStatus, REFRESH_MS);
    return () => clearInterval(timer);
    // eslint-disable-next-line
  }, []);

  if (!status?.state || status.state === 'OK') return null;

  const balance = status.balance != null ? formatNaira(Number(status.balance)) : null;
  const hours = status.hours_left != null ? Math.max(1, Math.round(Number(status.hours_left))) : null;
  const text =
    status.state === 'UNREADABLE'
      ? "Hethera can't read the VTpass balance. Check the VTpass account and API keys."
      : status.state === 'CRITICAL'
        ? `VTpass wallet is almost empty: ${balance}${hours ? ` (about ${hours} h)` : ''}. Purchases will start failing. Fund it now.`
        : `VTpass wallet is low: ${balance}${hours ? `, about ${hours} hours at the last 7 days' pace` : ''}. Please fund it.`;

  return (
    <Bar className={status.state.toLowerCase()} role='status'>
      <strong>{status.state === 'LOW' ? 'Low balance' : status.state === 'CRITICAL' ? 'Critical' : 'Balance unknown'}</strong>
      <span>{text}</span>
      {!status.alerts_enabled && <Muted>WhatsApp alerts are off (set OPS_ALERT_CHAT_IDS).</Muted>}
    </Bar>
  );
};

export default VtpassBalanceBanner;

const Bar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px 12px;
  padding: 12px 16px;
  margin-bottom: 20px;
  border-radius: 12px;
  font-size: 14px;
  border: 1px solid;

  &.low {
    background: #fff8e6;
    border-color: #f1d48a;
    color: #6b4a00;
  }
  &.critical,
  &.unreadable {
    background: #fdecea;
    border-color: #f2b8b5;
    color: #8a1c14;
  }
`;

const Muted = styled.span`
  font-size: 12px;
  opacity: 0.8;
`;
